import { BooleanInput, Filter as RaFilter, SearchInput } from "react-admin";

import React from "react";
import { ReferenceSelectInput } from "ra-friendsofbabba";

const Filters = (props) => (
  <RaFilter {...props}>
    <SearchInput source="q" alwaysOn fullWidth />
    <ReferenceSelectInput
      source="role_id"
      reference="roles"
      optionText="name"
      alwaysOn
    />
    <BooleanInput
      source="allow_local_login"
      defaultChecked
      defaultValue={true}
    />
  </RaFilter>
);
export default Filters;
